import React, { memo, useState } from 'react'

import styles from './index.module.scss'
import { useTranslation } from '@/services/i18n'
import editPng from '@/assets/images/inputIcon/bianji@2x.png'
import confirmPng from '@/assets/images/inputIcon/gou@2x.png'
import closePng from '@/assets/images/inputIcon/cha@2x.png'
import { MpcSignDetail, TxRecordsModel } from '@/services/apis/history/model'
import TxRecords from '@/services/apis/history/TxRecords'
import { Input } from 'antd'

interface Childprops {
  records: TxRecordsModel | MpcSignDetail
  id: string
}
const InfoNote = memo<Childprops>(props => {
  const { t } = useTranslation()
  const { records, id } = props

  const [isEdit, setIsEdit] = useState(false)
  const [note, setNote] = useState('')
  const [loading, setLoading] = useState(false)
  async function submit() {
    setLoading(true)
    const res = await TxRecords.setMpcNote(records.txKey, note, id)
    setLoading(false)
    if (res.success) {
      setIsEdit(false)
      records.note = note
    }
  }
  function edit() {
    setNote(records.note)
    setIsEdit(true)
  }
  return (
    <div>
      {records.note && !isEdit && (
        <div style={{ display: 'flex', maxWidth: '300px', wordBreak: 'break-word' }}>
          {records.note}

          <img
            src={editPng}
            alt=""
            className={styles.commonIcon}
            onClick={edit}
            style={{ height: '16px', width: '16px', marginLeft: '20px' }}
          />
        </div>
      )}
      {!records.note && !isEdit && (
        <div onClick={() => setIsEdit(true)} className={styles.noteText}>
          {t('common.add')}
        </div>
      )}
      {isEdit && (
        <div className={styles.edit}>
          <Input
            style={{ height: '24px', width: '380px', marginRight: '5px' }}
            placeholder={t('record.notePlaceholder') as any}
            value={note}
            disabled={loading}
            onChange={e => setNote(e.target.value)}
          />
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={closePng}
              alt=""
              className={styles.commonIcon}
              onClick={() => setIsEdit(false)}
              style={{ marginRight: '5px' }}
            />
            <img src={confirmPng} alt="" className={styles.commonIcon} onClick={submit} />
          </div>
        </div>
      )}
    </div>
  )
})

export default InfoNote
